module.exports = __webpack_public_path__ + "static/media/bitmap-07@3x.de2f5ff3.jpg";